jQuery(document).ready(function($) {
    var owl = $('.owl-carousel');
    owl.owlCarousel({
        margin: -200,
        center: true,
        loop: true,
        items: 1,
        lazyLoad: true,
        startPosition: 4,
        smartSpeed: 1000,
        nav: true,
        dots: false,
            responsive : {
        1024 : {
        items: 3
    }
},
        navText: [
            "<i class='icon-left'></i>",
            "<i class='icon-right'></i>"
        ]
    });

    $('.hamb--btn').click(function(){
        $('span:nth-child(2)').toggleClass('transparent');
        $('span:nth-child(1)').toggleClass('rotate-top');
        $('span:nth-child(3)').toggleClass('rotate-bottom');
    });


    function halfcalendar(){
        var tab = 'table tr.datepick-days-row td';
        $(tab).each(function (index, value) {
          //  console.log(tab + ' ' + index + ':' + $(this).attr('id'));

            if($(this).hasClass('date_approved') && $(this).prev().hasClass('date_available') ) {
                $(this).addClass('first');
            }
            else if($(this).hasClass('date_approved') && $(this).next().hasClass('date_available') ) {
                $(this).addClass('last');
            }
            // else if($(this).hasClass('date_approved') || $(this).prev().hasClass('date_approved') ) {
            //     $(this).removeClass('last');
            // }
            // else if($(this).hasClass('date_approved') || $('td').first() && $(this).next().hasClass('date_approved') ) {
            //     $(this).removeClass('first');
            // }
            else if($(this).hasClass('date2approve') && $(this).prev().hasClass('date_available')) {
                $(this).addClass('first');
            }
            else if($(this).hasClass('date2approve') && $(this).next().hasClass('date_available') ) {
                $(this).addClass('last');
            }
            else if($(this).hasClass('date_approved') &&  $(this).is(":first-child")) {
                $(this).addClass('first');
            }
            else if($(this).hasClass('date_approved') &&  $(this).is(":last-child")) {
                $(this).addClass('last');
            }
            else if($(this).hasClass('date2approve') &&  $(this).is(":first-child")) {
                $(this).addClass('first');
            }
            else if($(this).hasClass('date2approve') &&  $(this).is(":last-child")) {
                $(this).addClass('last');
            }


        });
    }

    $(document).on ("click", ".datepick-prev a", function () {
        halfcalendar();
    });

    $(document).on ("click", ".datepick-next a", function () {
        halfcalendar();
    });



    if($(window).width() > 1024){
        $('input[type="date"], input[type="datetime"], input[type="datetime-local"], input[type="month"], input[type="time"], input[type="week"]').each(function() {
            var el = this, type = $(el).attr('type');
            if ($(el).val() == '') $(el).attr('type', 'text');
            $(el).focus(function() {
                $(el).attr('type', type);
                el.click();
            });
            $(el).blur(function() {
                if ($(el).val() == '') $(el).attr('type', 'text');
            });
        });
    }

    if($("body").hasClass("home")){


        halfcalendar();

    var slide_ctrl = new ScrollMagic.Controller(
        {
            globalSceneOptions: {
                reverse: true
                // addIndicators: true
            }
        });


    var $slide0 = $('#apartament'),
        $slide1 = $('#galeria'),
        $slide2 = $('#atrakcje'),
        $slide3 = $('#cennik'),
        $slide4 = $('#kontakt');
    var slide0H = $slide0.outerHeight(true),
        slide1H = $slide1.outerHeight(true),
        slide2H = $slide2.outerHeight(true),
        slide3H = $slide3.outerHeight(true),
        slide4H = $slide4.outerHeight(true);

//scrollmagic scenes

    var section0_sa_menu = new ScrollMagic.Scene({triggerElement: '#apartament', duration: slide0H})
        .setClassToggle('.menu-item-5', 'active')
        .addTo(slide_ctrl);

    var section1_sa_menu = new ScrollMagic.Scene({triggerElement: '#galeria', duration: slide1H})
        .setClassToggle('.menu-item-6', 'active')
        .addTo(slide_ctrl);

    var section2_sa_menu = new ScrollMagic.Scene({triggerElement: '#atrakcje', duration: slide2H})
        .setClassToggle('.menu-item-7', 'active')
        .addTo(slide_ctrl);

    var section3_sa_menu = new ScrollMagic.Scene({triggerElement: '#cennik', duration: slide3H})
        .setClassToggle('.menu-item-8', 'active')
        .addTo(slide_ctrl);

    var section4_sa_menu = new ScrollMagic.Scene({triggerElement: '#kontakt', duration: slide3H + slide4H})
        .setClassToggle('.menu-item-10', 'active')
        .addTo(slide_ctrl);

    $(document).on("click", "a[href^='#']", function (e) {
        var id = $(this).attr("href");
        if ($(id).length > 0) {
            e.preventDefault();

            // trigger scroll
            slide_ctrl.scrollTo(id);
            // if supported by the browser we can even update the URL.
            if (window.history && window.history.pushState) {
                history.pushState("", document.title, id);
            }
        }
    });
    slide_ctrl.scrollTo(function (target) {
        TweenLite.to(window, 1.5, {
            scrollTo: {
                y: target - 25,
                autoKill: true // Allow scroll position to change outside itself
            },
            ease: Cubic.easeInOut
        });
    });

    var primaryColor = "#610000";
        function animate(){

    if($(window).width() >= 1024){
        var tl1 = new TimelineMax({reverse:true});
        tl1.to(".header",0.7,
            {css:{padding:"0 0 0 0", backgroundColor:"rgba(255,255,255,0.9)"},
                ease: Circ.easeIn});
        tl1.to(".top-bar a",0.6,{
            css:{color: primaryColor},
            ease: Circ.easeIn
        },"0");
        tl1.to(".cls-1",0.6,{
            css:{fill:primaryColor},
            ease: Circ.easeIn
        },"0");

        var header = new ScrollMagic.Scene({
            triggerElement: "#mainview__trigger",
            triggerHook: 0.13
        })
            .setTween(tl1) // trigger a TweenMax.to tween
       //      .addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
            .addTo(slide_ctrl);
    }

        }
    animate();
        //Recalculate on screen change
        $(window).on('resize', function () {
            animate();
        });


    }
});